export const hasLocationAnswer = (value: unknown) =>
  value !== null &&
  typeof value === 'object' &&
  'raw_address' in value &&
  'validation_status' in value;
